import React from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';

const dictionary = require("../dic/dic.json");

// Create a GraphQL mutation for comment submissions.
const commentSubmitQuery = gql`
	mutation($author: String, $commentOn: Int, $content: String, $authorEmail: String) {
		createComment(
			input: {
				clientMutationId: "CreateComment"
				author: $author
				commentOn: $commentOn
				content: $content
				authorEmail: $authorEmail
			}
		) {
			success
		}
	}
`;

// Our main component class.
class CommentForm extends React.Component {
	constructor(props) {
		super(props);
		// Set the initial state.
		this.state = {
			commentStatus: false,
			post: props.postId,
			comment: '',
			author: '',
			email: '',

		};
		// url: '',
		// Bind input changes.
		this.handleInputChange = this.handleInputChange.bind(this);
		this.showCommentForm = this.showCommentForm.bind(this);
	}

	// Handles input change events.
	handleInputChange(event) {
		const target = event.target;
		const value = event.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		// Sets the state of the input field.
		this.setState({
			[name]: value,
		});
	}

//Renders the comment form elements.
	showCommentForm(){
		const legal=dictionary[this.props.lang].contacto.acepto_condiciones;
		return (<div>
			<Mutation
				mutation={commentSubmitQuery}
				onCompleted={() => {
					this.setState({ commentStatus: 'success' });
				}}
				onError={(err) => {
					console.log("ERROR",err)
					this.setState({ commentStatus: 'error' });
				}}
			>
				{(addComment) => (
				<form  method="post" className="avia_ajax_form  comment-respond " id="respond"
						onSubmit={(event) => {
							// Prevent default form submit behavior.
							event.preventDefault();
							// Set initial loading state on submission.
							this.setState({ commentStatus: 'loading' });
							// Run the mutation.

							// grecaptcha.execute();
							addComment({
								variables: {
									author: this.state.author,
									commentOn: this.state.post,
									content: this.state.comment,
									authorEmail: this.state.email,
								},
							});
						}}
					>
					<span className="titlebar no-border">{dictionary[this.props.lang].title_comment}</span>
					<div id="commentEnviado" className="enviado-msg"><p>{dictionary[this.props.lang].comment_sent}</p></div>
					<div id="commentNoEnviado" className="enviado-msg" style={{backgroundColor: "#FF856A"}}><p>{dictionary[this.props.lang].comment_not_sent}</p></div>
					<div id="camposincumpletos" className="enviado-msg" style={{backgroundColor: "#FF856A"}}>{dictionary[this.props.lang].incomplete_fields}</div>
					<div className="comment-form">
						<textarea placeholder={dictionary[this.props.lang].content_commnet} name="comment" class="commentbody" id="comment" rows="5" tabindex="1" value={this.state.comment} onChange={this.handleInputChange}></textarea>
						<div className="row">
							<div className="col-sm-6">
								<input type="text" placeholder={dictionary[this.props.lang].name_comment} name="author" id="author" value="" size="22" tabindex="2" value={this.state.author} onChange={this.handleInputChange}/>
							</div>
							<div className="col-sm-6">
								<input type="text" placeholder={dictionary[this.props.lang].email_comment} name="email" id="email" value="" size="22" tabindex="3" value={this.state.email} onChange={this.handleInputChange}/>
							</div>
						</div>
						<div id="condiciones" className="col-12 form_element condiciones">
                      		<label className="checkbox-inline" for="acepto_condiciones">
                      			<input name="acepto_condiciones" value="1" type="checkbox" required />
                      			<span dangerouslySetInnerHTML={{__html:legal}} />
							</label>
                      		{/*<div id="recaptcha" className="g-recaptcha"
                             	data-sitekey="6LdfGGAbAAAAALYVC9a78PwEdgi1nwuhpveM41ZE" data-callback="onSubmit"
                             	data-size="invisible">
                     		</div>*/}
                		</div>
						<input name="submit" type="submit" className="boton-send sendcomment" value={dictionary[this.props.lang].comment_button} />
						{/* <p class="texto-legal">{dictionary[this.props.lang].privacy_policy}<a rel="nofollow" href="https://www.getbillage.com/es/politica-de-privacidad" target="_blank">{dictionary[this.props.lang].privacy_policy_2}</a>.</p> */}
					</div>


					</form>
				)}
			</Mutation>
      </div>
		);
	}

	// Render the comment form.
	render() {
		// Check comment status from component state and display messages or form.
		switch (this.state.commentStatus) {
			case 'success':
				return <div className="aviscomment">{dictionary[this.props.lang].comment_success}</div>;
			case 'loading':
				return <div className="aviscomment">{dictionary[this.props.lang].comment_loading}</div>;
			case 'error':
				return <div className="aviscomment">{dictionary[this.props.lang].comment_failed})</div>;
			default:
				return <div>{this.showCommentForm()}</div>;
		}
	}
}

export default CommentForm
